import React from "react";

function QuestionIcon(props) {
    return (
        <SvgIcon
            viewBox="0 0 320 512"
            {...props}>
            <path d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
        </SvgIcon>
    );
}

function CheckIcon(props) {
    return (
        <SvgIcon
            viewBox="0 0 448 512"
            {...props}>
            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
        </SvgIcon>
    );
}

function EyeSlashIcon(props) {
    return (
        <SvgIcon
            viewBox="0 0 640 512"
            {...props}>
            <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" />
        </SvgIcon>
    );
}

function TimesIcon(props) {
    return (
        <SvgIcon
            viewBox="0 0 384 512"
            {...props}>
            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
        </SvgIcon>
    );
}

function SvgIcon({ size = 12, viewBox, children, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox={viewBox}
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            {children}
        </svg>
    );
}

const STATUS_CONFIG = {
    0: {
        icon: QuestionIcon,
        color: "#f97316",
    },
    1: {
        icon: CheckIcon,
        color: "#22c55e",
    },
    2: {
        icon: EyeSlashIcon,
        color: "#22c55e",
    },
    3: {
        icon: TimesIcon,
        color: "#ef4444",
    },
};

export default function ReviewStatusIcon({ size = 16, status }) {
    const entry = STATUS_CONFIG[status];

    if (!entry) {
        return null;
    }

    const { icon: Icon, color } = entry;

    return (
        <div
            style={{
                width: size,
                height: size,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                border: `1px solid ${color}`,
                color,
                backgroundColor: "transparent",
                boxSizing: "border-box",
            }}>
            <Icon size={size * 0.75} />
        </div>
    );
}
